<template>
  <form
    novalidate
    class="mb-4"
    @submit.prevent="
      resetPlayer();
      name = '';
    "
  >
    <div class="flex">

      <div class="flex-grow  ">
        <input
          type="text"
          label="name"
          class="input-text"
          v-model="name"
          placeholder="Nouveau joueur"
        />
      </div>

      <ClassicButton
        v-if="name"
        type="submit"
        label="Ajouter"
        flexOption=""
        classButton="ml-2 button secondaryButton "
      />
      
    </div>
  </form>
</template>

<script>
import Config from "@/components/ui/config";
import ClassicButton from "@/components/ui/form/button/ClassicButton";

export default {
  props: {},
  data: function() {
    return {
      name: ""
    };
  },
  components: {
    ClassicButton
  },
  methods: {
    resetPlayer: function() {
      this.$emit("newPlayer", { name: this.name, color: this.randomColor() });
    },
    randomColor: function() {
      //return SKOR_COLORS;
      return Config.SKOR_COLORS[
        Math.floor(Math.random() * Config.SKOR_COLORS.length)
      ];
    }
  }
};
</script>
